module.exports = __webpack_public_path__ + "img/4573d5c.svg";